// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3P5z5","colMaxWidth":"Table_colMaxWidth__XX3oC"};